'use client';

import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

import { useStoreCard } from './store-card-context';

export type StreetProps = ComponentProps<'p'>;

export function Street({ className, ...props }: StreetProps) {
  const { store } = useStoreCard();

  return (
    <p
      className={twMerge(
        'w-full overflow-hidden overflow-ellipsis !whitespace-nowrap',
        className,
      )}
      {...props}
    >
      {store.address.streetAddress}
    </p>
  );
}
